/* eslint-disable  import/prefer-default-export */
var DATA_TESTID_SUFFIXES = {
  TITLE: 'title',
  EXPAND_COLLAPSE_BUTTON: 'expand-collapse-button',
  BODY: 'body',
  PIN_UNPIN_BUTTON: 'pin-unpin-button'
};

export { DATA_TESTID_SUFFIXES };
